import React, { useState } from 'react';
import { Alert } from 'antd';
import { useDropzone } from 'react-dropzone';

import { createDownloadFile, showToast } from 'utils/helpers';
import { downloadTemplateStore, importExcelStore } from 'services/store.service';

export default function ImportExcel({ onClose, handleImportDone }) {
  const { getRootProps, getInputProps, acceptedFiles } = useDropzone();
  const [uploading, setUploading] = useState(false);
  const [errorUpload, setErrorUpload] = useState(null);

  const handleDownloadTemplate = async (event) => {
    event.preventDefault();
    try {
      const response = await downloadTemplateStore();
      createDownloadFile(response?.data, 'mau-import-cua-hang.xlsx');
    } catch (error) {
      showToast.error(error?.message || 'Lỗi tải tập tin mẫu.');
    }
  };

  const handleImportExcel = async () => {
    const currentFile = acceptedFiles[0];
    if (!currentFile) {
      setErrorUpload('Vui lòng chọn tập tin tải lên.');
      return;
    }
    if (!currentFile?.name || !currentFile?.name.match(/\.(xlsx)$/i)) {
      setErrorUpload('Tập tin tải lên không đúng định dạng .xlsx.');
      return;
    }

    setUploading(true);
    setErrorUpload(null);
    try {
      const data = await importExcelStore(currentFile);
      handleImportDone(data);
    } catch (error) {
      const { errors, statusText, message } = error || {};
      const msg = [`${statusText || message || 'Lỗi tải lên tập tin!'}`].concat(errors || []).join('. ');
      setErrorUpload(msg);
    } finally {
      setUploading(false);
    }
  };

  return (
    <div className='bw_modal bw_modal_open' id='bw_store_import_excel'>
      <div className='bw_modal_container bw_filter'>
        <div className='bw_title_modal'>
          <h3>Nhập Excel cửa hàng</h3>
          <span className='bw_close_modal fi fi-rr-cross-small' onClick={onClose}></span>
        </div>
        <div className='bw_main_modal'>
          {errorUpload && <Alert closable className='bw_mb_2' type='error' message={errorUpload} />}
          <div className='bw_note'>
            <h3>Chú ý</h3>
            <p>Các cột đánh dấu * là bắt buộc khai báo.</p>
            <p>Hệ thống cập nhật theo Mã cửa hàng nếu đã tồn tại, không tạo trùng.</p>
            <p>Công ty, chi nhánh, khu vực và địa lý nhập đúng theo sheet tham chiếu trong file mẫu.</p>
            <p>
              Tải file mẫu danh sách tại{' '}
              <a href='/#' onClick={handleDownloadTemplate}>
                tại đây
              </a>
              .
            </p>
          </div>
          <label className='bw_import_file'>
            {uploading ? (
              'Đang tải lên ...'
            ) : (
              <section>
                <div {...getRootProps()}>
                  <input {...getInputProps()} />
                  <p className='dropzone-product-upload text-center font-weight-bold'>
                    <i className='fa fa-upload mr-1'></i>Kéo thả file hoặc tải lên từ thiết bị
                  </p>
                </div>
                {acceptedFiles[0] ? (
                  <div style={{ color: '#ef3434' }} className='font-weight-bold'>
                    Tập tin: {acceptedFiles[0]?.path || acceptedFiles[0]?.name}
                  </div>
                ) : null}
              </section>
            )}
          </label>
        </div>
        <div className='bw_footer_modal'>
          <button disabled={uploading} className='bw_btn bw_btn_success' onClick={handleImportExcel}>
            <span className='fi fi-rr-check'></span> Nhập file
          </button>
          <button type='button' className='bw_btn_outline bw_btn_outline_success' onClick={onClose}>
            <span className='fi fi-rr-cross-small'></span>
            Đóng
          </button>
        </div>
      </div>
    </div>
  );
}
